import { RECOIL_KEYS } from './recoilKeys'
import { atom, atomFamily } from 'recoil';


export const rc_menu_list = atom({
  key: RECOIL_KEYS.MENU_LIST,
  default: []
});

export const rc_menu = atom({
  key: RECOIL_KEYS.MENU,
  default: {}
});

export const rc_item_list = atom({
  key: RECOIL_KEYS.ITEM_LIST,
  default: []
});

export const rc_item = atom({
  key: RECOIL_KEYS.ITEM,
  default: {}
});
